class AnnouncementCarousel {
  constructor() {
    this.track = document.getElementById('announcement-track')
    this.prevBtn = document.getElementById('announcement-prev')
    this.nextBtn = document.getElementById('announcement-next')
    this.topBar = document.getElementById('top-bar')

    this.slides = null
    this.slideCount = 0
    this.currentIndex = 0
    this.autoplayTimer = null
    this.autoplayInterval = 5000

    this.init()
  }

  init() {
    if (!this.track || !this.prevBtn || !this.nextBtn) return

    this.slides = this.track.querySelectorAll('.announcement-slide')
    this.slideCount = this.slides.length

    if (this.topBar) {
      this.autoplayInterval = parseInt(this.topBar.dataset.autoplayInterval) || 5000
    }

    this.attachEventListeners()

    if (this.slideCount > 1) {
      this.startAutoplay()
    }
  }

  attachEventListeners() {
    this.nextBtn.addEventListener('click', (e) => {
      e.preventDefault()
      this.nextSlide()
      this.startAutoplay()
    })

    this.prevBtn.addEventListener('click', (e) => {
      e.preventDefault()
      this.prevSlide()
      this.startAutoplay()
    })

    if (this.slideCount > 1 && this.topBar) {
      this.topBar.addEventListener('mouseenter', () => this.stopAutoplay())
      this.topBar.addEventListener('mouseleave', () => this.startAutoplay())
    }
  }

  updateCarousel() {
    const percentage = -(this.currentIndex * 100)
    this.track.style.transform = `translateX(${percentage}%)`
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slideCount
    this.updateCarousel()
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.slideCount) % this.slideCount
    this.updateCarousel()
  }

  startAutoplay() {
    this.stopAutoplay()

    if (this.slideCount > 1) {
      this.autoplayTimer = setInterval(() => {
        this.nextSlide()
      }, this.autoplayInterval)
    }
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
      this.autoplayTimer = null
    }
  }

  goToSlide(index) {
    if (index >= 0 && index < this.slideCount) {
      this.currentIndex = index
      this.updateCarousel()
    }
  }

  static next() {
    const instance = window.announcementCarouselInstance
    if (instance) {
      instance.nextSlide()
    }
  }

  static prev() {
    const instance = window.announcementCarouselInstance
    if (instance) {
      instance.prevSlide()
    }
  }

  static goTo(index) {
    const instance = window.announcementCarouselInstance
    if (instance) {
      instance.goToSlide(index)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.announcementCarouselInstance = new AnnouncementCarousel()
})
